module.exports = __webpack_public_path__ + "img/SaludOnline.com.do.e51d0e95.svg";